var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"text"},[_vm._v(" 视频上传中（"+_vm._s(_vm.bar)+"%） ")]),_c('div',{staticClass:"track"},[_c('div',{staticClass:"bar",style:({ width: `${_vm.bar}%` })})]),_c('div',{staticClass:"cancel",on:{"click":_vm.cancel}},[_vm._v(" 取消 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }